/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_I_Frame_WidthInputs */

const en_tables_custom_pages_i_frame_width = /** @type {(inputs: Tables_Custom_Pages_I_Frame_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages I Frame Width`)
};

const de_tables_custom_pages_i_frame_width = /** @type {(inputs: Tables_Custom_Pages_I_Frame_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iFrame Breite`)
};

/**
* | output |
* | --- |
* | "Pages I Frame Width" |
*
* @param {Tables_Custom_Pages_I_Frame_WidthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_i_frame_width = /** @type {((inputs?: Tables_Custom_Pages_I_Frame_WidthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_I_Frame_WidthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_i_frame_width(inputs)
	return de_tables_custom_pages_i_frame_width(inputs)
});